import React from 'react';

import Lottie from 'react-lottie';
import AnimationTree from '../assets/animation/AnimationTree1.json';

export default function TreeAnimation(props) {
  const { width, height } = props;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: AnimationTree,
    renderer: 'svg',
  };
  return (
    <div>
      <Lottie options={defaultOptions} height={height} width={width} />
    </div>
  );
}
